import React from "react";
type BTBLogoProps = {
  size?: "sm" | "md" | "lg";
  className?: string;
};
const sizes = {
  sm: "h-10 w-10",
  md: "h-14 w-14",
  lg: "h-20 w-20"
};
export function BTBLogo({
  size = "md",
  className = ""
}: BTBLogoProps) {
  return <img src="https://cdn.magicpatterns.com/uploads/3Vp7cB9xA9jj3hG6KoePMo/Bangladesh_GOV_logo_2.png" alt="বাংলাদেশ সরকার ও বাংলাদেশ ট্যুরিজম বোর্ডের প্রতীক" className={`${sizes[size]} shrink-0 object-contain ${className}`} data-id="element-45" data-mp="3b58vjxmgupv3" />;
}